document.addEventListener('DOMContentLoaded', function() {
  const productList = document.querySelector('.product-list');
  const paginationWrapper = document.querySelector('.pagination-wrapper');
  
  if (!productList || !paginationWrapper) return;
  
  const totalPages = parseInt(paginationWrapper.dataset.totalPages || 1);
  let currentPage = parseInt(paginationWrapper.dataset.currentPage || 1);
  let isLoading = false;
  let lastLoadTime = 0;
  
  const infiniteScrollLoader = document.getElementById('infinite-scroll-loader');
  const allProductsLoaded = document.getElementById('all-products-loaded');
  const isSearchPage = window.location.pathname.includes('/search');

  const STORAGE_KEY = 'pagination_scroll_state';
  const PRODUCTS_STORAGE_KEY = 'pagination_products_state';
  const currentUrl = window.location.pathname + window.location.search.replace(/[?&]page=\d+/, '');
  
  const saveProductsState = () => {
    const products = Array.from(document.querySelectorAll('.product-list .card-product'));
    const productsData = products.map(product => {
      if (!product.dataset.productId) {
        const productLink = product.querySelector('a[href*="/products/"]');
        if (productLink) {
          const productId = productLink.href.match(/\/products\/([^\/\?]+)/)?.[1];
          if (productId) {
            const numericId = productLink.href.match(/\/products\/[^\/\?]*(\d+)/)?.[1];
            if (numericId) {
              product.dataset.productId = numericId;
            }
          }
        }
      }
      
      return {
        html: product.outerHTML,
        href: product.querySelector('a')?.href || '',
        title: product.querySelector('.card-product-name h3')?.textContent || ''
      };
    });
    
    const state = {
      url: currentUrl,
      products: productsData,
      currentPage: currentPage,
      totalPages: totalPages,
      timestamp: Date.now()
    };
    
    localStorage.setItem(PRODUCTS_STORAGE_KEY, JSON.stringify(state));
  };

  const restoreProductsState = () => {
    const savedState = localStorage.getItem(PRODUCTS_STORAGE_KEY);
    if (!savedState) return false;
    
    try {
      const state = JSON.parse(savedState);
      
      if (state.url !== currentUrl) {
        localStorage.removeItem(PRODUCTS_STORAGE_KEY);
        return false;
      }
      
      if (Date.now() - state.timestamp > 60 * 60 * 1000) {
        localStorage.removeItem(PRODUCTS_STORAGE_KEY);
        return false;
      }
      
      const currentProducts = document.querySelectorAll('.product-list .card-product');
      currentProducts.forEach(product => product.remove());
      
      state.products.forEach(productData => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = productData.html;
        const product = tempDiv.firstElementChild;
        if (product) {
          const productLinks = product.querySelectorAll('a[href*="/products/"]');
          productLinks.forEach(link => {
            link.removeAttribute('data-scroll-listener');
          });
          
          productList.appendChild(product);
        }
      });
      
      const paginationWrapper = productList.querySelector('.pagination-wrapper');
      if (paginationWrapper) {
        productList.appendChild(paginationWrapper);
      }
      
      currentPage = state.currentPage;
      
      setupProductClickListeners();
      
      // Update lazy load instance for restored products
      if (window.lazyLoadInstance) {
        window.lazyLoadInstance.update();
      }
      
      // Update vimeo facade for restored products
      if (window.vimeoFacade) {
        window.vimeoFacade.scan(productList);
      }
      
      return true;
    } catch (error) {
      localStorage.removeItem(PRODUCTS_STORAGE_KEY);
      return false;
    }
  };
  
  const saveScrollState = (clickedProductSelector = null) => {
    const state = {
      url: currentUrl,
      scrollY: window.scrollY,
      currentPage: currentPage,
      clickedProductSelector: clickedProductSelector,
      timestamp: Date.now()
    };
    
    const storageKey = STORAGE_KEY;
    
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
      // Silent fail
    }
  };

  const restoreScrollState = async () => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    
    const productsRestored = restoreProductsState();
    
    let savedState = null;
    let foundKey = null;
    
    savedState = sessionStorage.getItem(STORAGE_KEY);
    if (savedState) {
      foundKey = STORAGE_KEY;
    }
    
    if (savedState) {
      try {
        const state = JSON.parse(savedState);
        if (state.url === currentUrl && Date.now() - state.timestamp < 30 * 60 * 1000) {
          window.scrollTo(0, 0);
          
          if (state.clickedProductSelector) {
            const waitForProductPosition = (selector, maxAttempts = 10) => {
              return new Promise((resolve) => {
                let attempts = 0;
                const checkPosition = () => {
                  const productElement = document.querySelector(selector);
                  if (productElement && productElement.offsetTop > 0) {
                    resolve(productElement);
                  } else if (attempts < maxAttempts) {
                    attempts++;
                    setTimeout(checkPosition, 100);
                  } else {
                    resolve(null);
                  }
                };
                checkPosition();
              });
            };
            
            waitForProductPosition(state.clickedProductSelector).then((productElement) => {
              if (productElement) {
                productElement.scrollIntoView({ 
                  behavior: 'instant',
                  block: 'start'
                });
                
                setTimeout(() => {
                  const currentScroll = window.scrollY;
                  const finalScroll = Math.max(0, currentScroll - 130);
                  window.scrollTo(0, finalScroll);
                }, 50);
              } else {
                window.scrollTo({
                  top: state.scrollY,
                  behavior: 'smooth'
                });
              }
            });
          } else {
            setTimeout(() => {
              window.scrollTo({
                top: state.scrollY,
                behavior: 'smooth'
              });
            }, 200);
          }
          
          setTimeout(() => {
            if ('scrollRestoration' in history) {
              history.scrollRestoration = 'auto';
            }
          }, 1000);
          
          return true;
        }
      } catch (error) {
        // Silent fail
      }
    }
    
    if (productsRestored) {
      return true;
    }
    
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    
    let fallbackSavedState = null;
    let fallbackFoundKey = null;
    
    fallbackSavedState = sessionStorage.getItem(STORAGE_KEY);
    if (fallbackSavedState) {
      fallbackFoundKey = STORAGE_KEY;
    } else {
      let newestTimestamp = 0;
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith(STORAGE_KEY + '_product_')) {
          const testState = sessionStorage.getItem(key);
          if (testState) {
            try {
              const parsedState = JSON.parse(testState);
              if (parsedState.url === currentUrl && parsedState.timestamp > newestTimestamp) {
                fallbackSavedState = testState;
                fallbackFoundKey = key;
                newestTimestamp = parsedState.timestamp;
              }
            } catch (e) {
              // Ignorar estados inválidos
            }
          }
        }
      }
    }
    
    if (!fallbackSavedState) {
      return false;
    }

    try {
      const state = JSON.parse(fallbackSavedState);
      
      if (state.url !== currentUrl) {
        return false;
      }
      
      if (Date.now() - state.timestamp > 30 * 60 * 1000) {
        return false;
      }

      if (state.currentPage > currentPage) {
        const wasScrollListenerActive = scrollListenerAdded;
        if (wasScrollListenerActive) {
          removeScrollListeners();
        }
        
        try {
          await loadPagesUntil(state.currentPage);
        } catch (error) {
          // Silent fail
        } finally {
          if (wasScrollListenerActive && currentPage < totalPages) {
            if (!scrollListenerAdded) {
              window.addEventListener('scroll', handleScroll, { passive: true });
              scrollListenerAdded = true;
            }
          }
        }
      }

      window.scrollTo(0, 0);
      
      if (state.clickedProductSelector) {
        const waitForProductPosition = (selector, maxAttempts = 15) => {
          return new Promise((resolve) => {
            let attempts = 0;
            const checkPosition = () => {
              const productElement = document.querySelector(selector);
              if (productElement && productElement.offsetTop > 0) {
                resolve(productElement);
              } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(checkPosition, 100);
              } else {
                resolve(null);
              }
            };
            checkPosition();
          });
        };
        
        waitForProductPosition(state.clickedProductSelector).then((productElement) => {
          if (productElement) {
            const elementPosition = productElement.offsetTop;
            const offsetPosition = elementPosition - 130;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          } else {
            window.scrollTo({
              top: state.scrollY,
              behavior: 'smooth'
            });
          }
        });
      } else {
        setTimeout(() => {
          window.scrollTo({
            top: state.scrollY,
            behavior: 'smooth'
          });
        }, 500);
      }

      setTimeout(() => {
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'auto';
        }
      }, 1000);
      
      return true;
    } catch (error) {
      return false;
    }
  };

  const removeScrollListeners = () => {
    window.removeEventListener('scroll', handleScroll);
    document.removeEventListener('scroll', handleScroll);
    scrollListenerAdded = false;
  };

  const setupProductClickListeners = () => {
    const productLinks = document.querySelectorAll('.card-product a, .product-item a, [href*="/products/"]');
    const newLinks = Array.from(productLinks).filter(link => !link.dataset.scrollListener);
    
    if (newLinks.length > 0) {
      newLinks.forEach((link, index) => {
        link.addEventListener('click', () => {
          if (link.href.includes('/products/')) {
            const productElement = link.closest('.card-product');
            const productId = productElement ? productElement.dataset.productId : null;
            const productSelector = productId ? `.card-product[data-product-id="${productId}"]` : null;
            
            saveScrollState(productSelector);
            saveProductsState();
          }
        });
        link.dataset.scrollListener = 'true';
      });
    }
  };

  const clearSavedStates = () => {
    localStorage.removeItem(PRODUCTS_STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
  };

  window.clearPaginationStates = clearSavedStates;

  setupProductClickListeners();

  restoreScrollState();

  // Função para inserir banner após os produtos de uma página
  const insertCollectionBanner = (pageNumber, insertAfterElement = null) => {
    const productList = document.querySelector('.product-list');
    if (!productList) return;
    
    // Se for a página 1, não precisa inserir (já vem do Liquid)
    if (pageNumber === 1) return;
    
    // Verificar se já existe banner para esta página
    const existingBanner = productList.querySelector(`.collection-page-banner[data-page="${pageNumber}"]`);
    if (existingBanner) return;
    
    const bannersDataScript = document.getElementById('collection-banners-data');
    if (!bannersDataScript) return;
    
    try {
      const banners = JSON.parse(bannersDataScript.textContent);
      if (!banners || banners.length === 0) return;
      
      // Calcular qual banner mostrar (com loop se necessário)
      const bannerIndex = (pageNumber - 1) % banners.length;
      const bannerBlock = banners[bannerIndex];
      
      if (!bannerBlock || !bannerBlock.settings) return;
      
      // Criar elemento do banner
      const bannerWrapper = document.createElement('div');
      bannerWrapper.className = 'collection-page-banner';
      bannerWrapper.setAttribute('data-page', pageNumber);
      bannerWrapper.setAttribute('data-banner-index', bannerIndex);
      bannerWrapper.style.width = '100%';
      bannerWrapper.style.flexBasis = '100%';
      
      // Criar conteúdo do banner
      const bannerItem = document.createElement('div');
      bannerItem.className = 'collection-banner-item horizontal-banner';
      
      const bannerBlockDiv = document.createElement('div');
      bannerBlockDiv.className = 'horizontal-banner-block';
      
      let bannerContent = '';
      
      // Desktop banner
      if (bannerBlock.settings.banner_video_desktop) {
        bannerContent += `<video class="horizontal-banner-media desktop" autoplay loop muted playsinline loading="lazy" aria-label="Banner video desktop">
          <source src="${bannerBlock.settings.banner_video_desktop}" type="video/mp4">
        </video>`;
      } else if (bannerBlock.settings.banner_image_desktop) {
        const img = bannerBlock.settings.banner_image_desktop;
        let imageUrlDesktop = '';
        let width = '';
        let height = '';
        
        if (typeof img === 'object') {
          imageUrlDesktop = img.url || img.src || '';
          width = img.width || '';
          height = img.height || '';
        } else {
          imageUrlDesktop = img;
        }

        if (imageUrlDesktop) {
          bannerContent += `<img src="${imageUrlDesktop}" width="${width}" height="${height}" alt="" loading="lazy" class="horizontal-banner-media desktop" style="width: 100%; height: auto;">`;
        }
      }
      
      // Mobile banner
      if (bannerBlock.settings.banner_video_mobile) {
        bannerContent += `<video class="horizontal-banner-media mobile" autoplay loop muted playsinline loading="lazy" aria-label="Banner video mobile">
          <source src="${bannerBlock.settings.banner_video_mobile}" type="video/mp4">
        </video>`;
      } else if (bannerBlock.settings.banner_image_mobile) {
        const img = bannerBlock.settings.banner_image_mobile;
        let imageUrlMobile = '';
        let width = '';
        let height = '';

        if (typeof img === 'object') {
          imageUrlMobile = img.url || img.src || '';
          width = img.width || '';
          height = img.height || '';
        } else {
          imageUrlMobile = img;
        }

        if (imageUrlMobile) {
          bannerContent += `<img src="${imageUrlMobile}" width="${width}" height="${height}" alt="" loading="lazy" class="horizontal-banner-media mobile" style="width: 100%; height: auto;">`;
        }
      } else if (bannerBlock.settings.banner_image_desktop) {
        // Fallback: usar imagem desktop no mobile se não houver imagem mobile
        const img = bannerBlock.settings.banner_image_desktop;
        let imageUrlDesktop = '';
        let width = '';
        let height = '';

        if (typeof img === 'object') {
          imageUrlDesktop = img.url || img.src || '';
          width = img.width || '';
          height = img.height || '';
        } else {
          imageUrlDesktop = img;
        }

        if (imageUrlDesktop) {
          bannerContent += `<img src="${imageUrlDesktop}" width="${width}" height="${height}" alt="" loading="lazy" class="horizontal-banner-media mobile" style="width: 100%; height: auto;">`;
        }
      }
      
      if (bannerBlock.settings.banner_link && bannerContent) {
        bannerBlockDiv.innerHTML = `<a href="${bannerBlock.settings.banner_link}" aria-label="Banner link">${bannerContent}</a>`;
      } else if (bannerContent) {
        bannerBlockDiv.innerHTML = bannerContent;
      }
      
      if (bannerContent) {
        bannerItem.appendChild(bannerBlockDiv);
        bannerWrapper.appendChild(bannerItem);
        
        // Inserir logo após o elemento especificado (último produto carregado)
        if (insertAfterElement) {
          insertAfterElement.insertAdjacentElement('afterend', bannerWrapper);
        } else {
          // Fallback: inserir após o último produto ou antes do pagination-wrapper
          const lastProduct = productList.querySelector('.card-product:last-child');
          const paginationWrapper = document.querySelector('.pagination-wrapper');
          
          if (lastProduct) {
            lastProduct.insertAdjacentElement('afterend', bannerWrapper);
          } else if (paginationWrapper) {
            productList.insertBefore(bannerWrapper, paginationWrapper);
          } else {
            productList.appendChild(bannerWrapper);
          }
        }
        
        // Atualizar lazy load para o novo banner
        if (window.lazyLoadInstance) {
          window.lazyLoadInstance.update();
        }
      }
    } catch (error) {
      console.error('Erro ao inserir banner:', error);
    }
  };

  if (currentPage >= totalPages) {
    if (allProductsLoaded) allProductsLoaded.style.display = 'block';
    if (infiniteScrollLoader) infiniteScrollLoader.style.display = 'none';
    return;
  }

  const loadMoreProducts = async () => {
    const now = Date.now();
    const timeSinceLastLoad = now - lastLoadTime;
    
    if (isLoading || currentPage >= totalPages) {
      return;
    }
    
    if (timeSinceLastLoad < 500) {
      return;
    }
    
    isLoading = true;
    lastLoadTime = now;
    if (infiniteScrollLoader) infiniteScrollLoader.style.display = 'flex';
    if (allProductsLoaded) allProductsLoaded.style.display = 'none';

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('page', currentPage + 1);

      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      let newProducts;
      if (isSearchPage) {
        newProducts = Array.from(doc.querySelectorAll('.product-list .card-product')).filter(product => 
          product.closest('.product-list') !== null
        );
      } else {
        newProducts = doc.querySelectorAll('.product-list .card-product');
      }
      
      if (newProducts.length > 0) {
        const lastProductBefore = productList.querySelector('.card-product:last-child');
        
        newProducts.forEach((product, index) => {
          const clonedProduct = product.cloneNode(true);
          productList.appendChild(clonedProduct);
        });
        
        setupProductClickListeners();
        
        // Inserir banner logo após os produtos recém-carregados
        const lastProductAfter = productList.querySelector('.card-product:last-child');
        if (lastProductAfter) {
          insertCollectionBanner(currentPage + 1, lastProductAfter);
        } else {
          insertCollectionBanner(currentPage + 1);
        }
        
        // Update lazy load instance for new products
        if (window.lazyLoadInstance) {
          window.lazyLoadInstance.update();
        }
        
        // Update vimeo facade for new products
        if (window.vimeoFacade) {
          window.vimeoFacade.scan(productList);
        }
        
        // Reinicializar quick buy para novos produtos (com pequeno delay para garantir DOM atualizado)
        setTimeout(() => {
          if (window.CardProductQuickBuyInstance) {
            const newQuickBuyContainers = productList.querySelectorAll('.card-product-quick-buy:not([data-quick-buy-initialized])');
            if (newQuickBuyContainers.length > 0) {
              window.CardProductQuickBuyInstance.init(newQuickBuyContainers);
            }
          }
        }, 100);
        
        currentPage++;
        
        saveProductsState();
        
        if (currentPage >= totalPages) {
          if (infiniteScrollLoader) infiniteScrollLoader.style.display = 'none';
          if (allProductsLoaded) allProductsLoaded.style.display = 'block';
          removeScrollListeners();
        }
      } else {
        if (infiniteScrollLoader) infiniteScrollLoader.style.display = 'none';
        if (allProductsLoaded) allProductsLoaded.style.display = 'block';
        removeScrollListeners();
      }
    } catch (error) {
      if (infiniteScrollLoader) infiniteScrollLoader.style.display = 'none';
    } finally {
      isLoading = false;
    }
  };

  const loadPagesUntil = async (targetPage) => {
    let attempts = 0;
    
    while (currentPage < targetPage && currentPage < totalPages && attempts < 20) {
      attempts++;
      
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('page', currentPage + 1);

        const response = await fetch(url.toString());
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        let newProducts;
        if (isSearchPage) {
          newProducts = Array.from(doc.querySelectorAll('.product-list .card-product')).filter(product => 
            product.closest('.product-list') !== null
          );
        } else {
          newProducts = doc.querySelectorAll('.product-list .card-product');
        }
        
        if (newProducts.length > 0) {
          newProducts.forEach(product => {
            const clonedProduct = product.cloneNode(true);
            productList.appendChild(clonedProduct);
          });
          
          // Update lazy load instance for new products
          if (window.lazyLoadInstance) {
            window.lazyLoadInstance.update();
          }

          // Update vimeo facade for new products
          if (window.vimeoFacade) {
            window.vimeoFacade.scan(productList);
          }
          
          // Reinicializar quick buy para novos produtos (com pequeno delay para garantir DOM atualizado)
          setTimeout(() => {
            if (window.CardProductQuickBuyInstance) {
              const newQuickBuyContainers = productList.querySelectorAll('.card-product-quick-buy:not([data-quick-buy-initialized])');
              if (newQuickBuyContainers.length > 0) {
                window.CardProductQuickBuyInstance.init(newQuickBuyContainers);
              }
            }
          }, 100);
          
          currentPage++;
          
          if (currentPage >= totalPages) {
            break;
          }
        } else {
          break;
        }
      
        await new Promise(resolve => setTimeout(resolve, 300));
      
      } catch (error) {
        break;
      }
    }
  };

  let scrollTimeout;
  let scrollListenerAdded = false;
  
  const handleScroll = () => {
    if (isLoading || currentPage >= totalPages) {
      return;
    }
    
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const { scrollTop, scrollHeight, clientHeight } = productList;
      const viewportHeight = window.innerHeight;
      const threshold = viewportHeight * 1.5;
      
      const triggerPoint = scrollHeight - threshold;
      const currentPoint = scrollTop + clientHeight;
      const shouldTrigger = currentPoint >= triggerPoint;
      
      if (shouldTrigger) {
        loadMoreProducts();
      }
    }, 100);
  };

  const addScrollListener = () => {
    if (!scrollListenerAdded) {
      window.addEventListener('scroll', handleScroll, { passive: true });
      scrollListenerAdded = true;
    }
  };

  addScrollListener();

  setTimeout(() => {
    if (currentPage < totalPages && !isLoading) {
      const { scrollTop, scrollHeight, clientHeight } = productList;
      const viewportHeight = window.innerHeight;
      const threshold = viewportHeight * 1.5;
      
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - threshold;
      const isPageTooShort = scrollHeight < viewportHeight * 1.5;
      
      if (isNearBottom || isPageTooShort) {
        handleScroll();
      }
    }
  }, 1000);

  const spinner = document.querySelector('.spinner');
  if (spinner) {
    let rotation = 0;
    
    function rotateSpinner() {
      rotation += 8;
      spinner.style.transform = `rotate(${rotation}deg)`;
      requestAnimationFrame(rotateSpinner);
    }
    
    rotateSpinner();
  }
});